import { graphQueryBang } from "shared/lib/graphql"
import { gql } from "shared/lib/graphql"

const UserGroupDeleteMutation = gql`
  mutation($group_guid: String!) {
    userGroupDelete(input: { group_guid: $group_guid }) {
      errors {
        attribute
        message
      }
    }
  }
`

export const deleteGroup = async (guid: string) =>
  graphQueryBang(UserGroupDeleteMutation, { group_guid: guid })
